import { useMutation } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import axios from "axios";

export const GUEST_CHECKOUT_EMAIL_KEY = "guestCheckoutEmail";
export const CHECKOUT_COMPLETED_KEY = "stexCheckoutCompleted";

const checkout = async (checkoutData, token) => {
  const response = await axios.post(
    `${process.env.REACT_APP_SERVER_URL}/order/checkout`,
    checkoutData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

const guestCheckout = async (checkoutData) => {
  const response = await axios.post(
    `${process.env.REACT_APP_SERVER_URL}/order/guest-checkout`,
    checkoutData,
    { headers: { "Content-Type": "application/json" } }
  );
  return response.data;
};

const useCheckout = () => {
  const { token, isLoggedIn } = useContext(AuthContext);

  return useMutation((checkoutData) => {
    if (isLoggedIn && token) {
      return checkout(checkoutData, token);
    }
    return guestCheckout(checkoutData);
  });
};

export default useCheckout;
